import * as React from 'react';
import { SignInPane } from '../../components/organisms/sign_in/SignInPane';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { RouteComponentProps } from 'react-router';
import { observable, makeObservable } from 'mobx';
import { parseQueryParams } from '../../../mainv3/types/location';
import { observer } from 'mobx-react';
import { AccountRoutes } from '../../routes/AccountRoutes';

type Props = RouteComponentProps;

export const SignInPage = observer(
  class SignInPage extends React.Component<Props> {
    redirectUrl: string | string[] | null = null;

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        redirectUrl: observable,
      });
    }

    componentDidMount(): void {
      const { redirect_url } = parseQueryParams(this.props.location);
      this.redirectUrl = redirect_url ? redirect_url : AccountRoutes.profile().stringify();
      GlobalStatesV3.currentUser.reloadUser();
    }

    render() {
      return <SignInPane redirectUrl={this.redirectUrl || undefined} supportNewUser={true} />;
    }
  }
);
